export default {
  'marketingMessages.goToSlide': 'Go to slide <%= num %>',
  'marketingMessages.marketMessages': 'Market Messages',
  'marketingMessages.SlideOf': 'Slide <%= num %> of <%= length %>'
};
